/**
 * Inservice External Integrations
 * Inservice external integrations API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CalendarConfigurationUserSettingsDto } from './calendarConfigurationUserSettingsDto';


export interface CalendarConfigurationDto { 
    id: string;
    realId: string;
    /**
     * Only available to admin? Should be taken from token for a regular user
     */
    userId: string;
    provider: CalendarConfigurationDto.ProviderEnum;
    isPrimary?: boolean;
    primaryCalendarId: string;
    userSettings?: CalendarConfigurationUserSettingsDto;
}
export namespace CalendarConfigurationDto {
    export type ProviderEnum = 'google' | 'office365' | 'icloud' | 'outlook';
    export const ProviderEnum = {
        Google: 'google' as ProviderEnum,
        Office365: 'office365' as ProviderEnum,
        Icloud: 'icloud' as ProviderEnum,
        Outlook: 'outlook' as ProviderEnum
    };
}


